<template>
  <div class="content-main fadeIn animated">
    <transition
      name="form-animation"
      leave-active-class="animated fadeOut">
      <div
        v-if="open"
        class="main-modal" >
        <el-button
          class="close-button"
          @click="onCloseModal">
          <i class="icon-x"/>
        </el-button>
        <slot/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FormModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: true
    }
  },
  methods: {
    onCloseModal () {
      this.open = false
      setTimeout(() => {
        this.$emit('closeModal')
      }, 300)
    }
  }
}
</script>

<style scoped lang="scss">
.content-main{
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 2001;
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  .main-modal{
    position: fixed;
    background-color: #ffffff;
    z-index: 2001;
    min-width: 350px;
    overflow: auto;
    border-radius: 5px;
    .close-button{
      border: none;
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 20px;
      z-index: 100;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_shared/form-modal.vue